import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `/templates/calculation/create`; old bookmarks and links still land here.
export const Route = createFileRoute('/_authenticated/templates/calculation/add-template')({
    // Only redirects: `create` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/templates/calculation/create', search: true, replace: true });
    },
});
